import { render, staticRenderFns } from "./ArticleOfDistributor.vue?vue&type=template&id=061d2cf3&scoped=true"
import script from "./ArticleOfDistributor.vue?vue&type=script&lang=js"
export * from "./ArticleOfDistributor.vue?vue&type=script&lang=js"
import style0 from "./ArticleOfDistributor.vue?vue&type=style&index=0&id=061d2cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061d2cf3",
  null
  
)

export default component.exports